<template>
  <!-- 抱怨单闭环确认 -->
  <h-inspection-page :title="h_i18n('402e34f03269c71f61246ceb8119b65d')" @inspection-update="inspectionUpdate">
    <inspection-header :title="h_i18n('45f148242e1d295b25aebfecd99fa0ec')" title-height="80px">
      <template #title>
        <h-p :title="h_i18n('f3737dbfae61193590bd513df85ff250')" align="left" style="margin-left: 10px">{{ data.complainCode }}</h-p>
      </template>
      <template #body>
        <tr>
          <h-td :title="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')" colspan="2">{{ data.form.supplyCode }}</h-td>
          <h-td :title="h_i18n('9190cc22c9ba377113bc54ac51013a0b')" colspan="2">{{ data.form.supplyName }}</h-td>
        </tr>
        <tr>
          <h-td :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" colspan="2">{{ data.form.mtlNo }}</h-td>
          <h-td :title="h_i18n('aae11e21d2ef24d030976e023bc44ff5')" colspan="2">{{ data.form.mtlName }}</h-td>
        </tr>
        <tr>
          <h-td :title="h_i18n('b060eca2b49819ee8ccebe9df36f3a2c')" colspan="2">
            <span v-if="data.form.complainProperty == '1318'">{{ h_i18n('7da53c134906667f0f41bfc4ffc3a332') }}</span>
            <span v-if="data.form.complainProperty == '1319'">{{ h_i18n('8ebcc275e6f0191070f991439d6be6cb') }}</span>
          </h-td>
          <h-td :title="h_i18n('a0ecbfa1e4cdb310961027f6ab4083dd')" colspan="2">
            <span v-if="data.form.complainType == '1320'">{{ h_i18n('12fd7edf0f9783427f8bbf8113ed2b4a') }}</span>
            <span v-else-if="data.form.complainType == '1321'">{{ h_i18n('1967fed0fd54bc07843c301ff2d060c6') }}</span>
            <span v-else-if="data.form.complainType == '1322'">{{ h_i18n('6b8a7ec3797f56ce960c06dde05b90eb') }}</span>
            <span v-else-if="data.form.complainType == '1324'">{{ h_i18n('0b7aaf3f0230aa297fda6eafe47ebc40') }}</span>
            <span v-else-if="data.form.complainType == '1327'">{{ h_i18n('4220e1ddc42458b5b5ae0bba313957a9') }}</span>
            <span v-else-if="data.form.complainType == '1328'">{{ h_i18n('2d4b2c6a6673b0508f2b1b4e1e5bbc34') }}</span>
            <span v-else-if="data.form.complainType == '2171'">{{ h_i18n('fc673133331353ca7fbc655919c732e6') }}</span>
            <span v-else-if="data.form.complainType == '2287'">{{ h_i18n('d8361dd95cf2096a020431a406f49820') }}</span>
            <span v-else-if="data.form.complainType == '2288'">{{ h_i18n('e414a703a6ae0f7031fd968aab0a5b52') }}</span>
            <span v-else>{{ data.form.complainType }}</span>
          </h-td>
        </tr>
        <template v-if="data.form.complainType !== 1321">
          <tr>
            <h-td :title="h_i18n('8552ca527b5abdfc16727e8886b194f5')" colspan="2">{{ data.form.happenSybName }}</h-td>
            <h-td :title="h_i18n('a8e450d03efd4f33232169538abcec3e')" colspan="2">
              <span v-if="data.form.happenNode == 1335">{{ h_i18n('5be77cbffda8cb572d17e7cccfde5dd4') }}</span>
              <span v-else-if="data.form.happenNode == 1336">{{ h_i18n('0653329dcfb42539677f84b3bd94b826') }}</span>
              <span v-else-if="data.form.happenNode == 1337">{{ h_i18n('a3c853b28fc22514a82e9b97550a5bb8') }}</span>
              <span v-else-if="data.form.happenNode == 1338">{{ h_i18n('3b9d92eca3709a56edfed5be784406cb') }}</span>
              <span v-else-if="data.form.happenNode == 1339">{{ h_i18n('eb7b9e9f7281fe68d0dc4c631a522eca') }}</span>
              <span v-else-if="data.form.happenNode == 2999">{{ h_i18n('f5a6a3a1e5bcddf045542b92ff04a564') }}</span>
              <span v-else>{{ data.form.happenNode }}</span>
            </h-td>
          </tr>
          <tr>
            <h-td :title="h_i18n('13f7745f1c4f6c0fe0335ba69d87f53e')" colspan="5">{{ data.form.happenDate }}</h-td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <h-td :title="h_i18n('735d49a299ac9bc2db6056ab586633ce')" colspan="2">{{ data.form.claimCode }}</h-td>
            <h-td :title="h_i18n('8552ca527b5abdfc16727e8886b194f5')" colspan="2">{{ data.form.happenSybName }}</h-td>
          </tr>
          <tr>
            <h-td :title="h_i18n('a8e450d03efd4f33232169538abcec3e')" colspan="2">
              <span v-if="data.form.happenNode == 1335">{{ h_i18n('5be77cbffda8cb572d17e7cccfde5dd4') }}</span>
              <span v-else-if="data.form.happenNode == 1336">{{ h_i18n('0653329dcfb42539677f84b3bd94b826') }}</span>
              <span v-else-if="data.form.happenNode == 1337">{{ h_i18n('a3c853b28fc22514a82e9b97550a5bb8') }}</span>
              <span v-else-if="data.form.happenNode == 1338">{{ h_i18n('3b9d92eca3709a56edfed5be784406cb') }}</span>
              <span v-else-if="data.form.happenNode == 1339">{{ h_i18n('eb7b9e9f7281fe68d0dc4c631a522eca') }}</span>
              <span v-else-if="data.form.happenNode == 2999">{{ h_i18n('f5a6a3a1e5bcddf045542b92ff04a564') }}</span>
              <span v-else>{{ data.form.happenNode }}</span>
            </h-td>
            <h-td :title="h_i18n('13f7745f1c4f6c0fe0335ba69d87f53e')" colspan="2">{{ data.form.happenDate }}</h-td>
          </tr>
        </template>
        <tr>
          <h-td :title="h_i18n('330a379d158db9252e21d1a6207aa296')" colspan="5">{{ data.form.workNum }}</h-td>
        </tr>
        <tr>
          <h-td :title="h_i18n('318fac0104c51cb87071ef7d581dd75c')" colspan="5">{{ data.form.complainDescription }}</h-td>
        </tr>
        <tr>
          <!-- 抱怨资料 -->
          <h-td :title="h_i18n('9790cf50803f2dcecf21ab335cf53ac3')" colspan="5">
            <template v-if="data.form.createType==0 && data.form.complainType==2171">
              <span v-if="data.form.complainFileName" style="display: flex; flex-wrap: wrap; gap: 8px;">
                <span v-for="(item, index) in complainFiles" :key="index" @click="handleDownloadComplain(item.name, item.uuid)">
                  <span class="blueClick">{{ item.name }}</span>
                </span>
              </span>
              <span v-else>-</span>
            </template>
            <div v-else
              style="color: #165dff; font-size: 14px; cursor: pointer"
              @click="handleClickComplain(data.form.complainFileName, data.form.complainFileUuid)"
            >
              {{ data.form.complainFileName }}
            </div>
          </h-td>
        </tr>
        <tr>
          <h-td :title="h_i18n('b52322e39e0214deef7d2b8515e9dd92')" colspan="2">{{ data.form.rectificationDescription }}</h-td>
          <h-td :title="h_i18n('9947fc5342d994ab21610c7a02fb120e')" colspan="2">{{ data.form.rectificationTime }}</h-td>
        </tr>
        <tr>
          <h-td :title="h_i18n('ae27d6f465386eb63210704c8918c6c4')" colspan="2">*</h-td>
          <!-- <h-td title="录入人" colspan="2">{{ data.form.isrtEmpName }}</h-td> -->
          <h-td :title="h_i18n('0039880117c13787732d259f5bc9f7f5')" colspan="2">{{ data.form.isrtDate }}</h-td>
        </tr>
        <tr>
          <h-td :title="h_i18n('5e33e487aa949c424f6a4cf84a2d6fab')" colspan="5">{{ data.form.isrtEmpRoleName }}</h-td>
        </tr>
      </template>
    </inspection-header>
    <div class="tab_box">
      <el-tabs v-model="data.activeName" type="border-card" class="tabs_style" @tab-click="handleClick">
        <el-tab-pane name="first" :label="h_i18n('0575a1fbdb1473cf7d2323ad5236bca3')" v-if="!(data.form.createType==0 && data.form.complainType==2171)">
          <div class="tabs">
            <el-row :gutter="20" style="margin-top: 15px">
              <el-col :span="4">
                <div class="title">{{ h_i18n('5b656bfbb4a3932597d47691983dccee') }}</div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-input v-model="data.form.approveConclusionName" disabled />
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 15px">
              <el-col :span="4">
                <div class="title">{{ h_i18n('f6671bd136737270c2720e3b2a152039') }}</div>
              </el-col>
              <el-col :span="20">
                <div
                  style="color: #165dff; font-size: 14px; cursor: pointer"
                  @click="handleClickComplain(data.form.leaderFileName, data.form.leaderFileUuid)"
                >
                  {{ data.form.leaderFileName }}
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 15px">
              <el-col :span="4">
                <div class="title">{{ h_i18n('f5c361d5c4369e1bb513e170fcf16835') }}</div>
              </el-col>
              <el-col :span="20">
                <div>
                  <el-input v-model="data.form.approveMessage" :rows="4" type="textarea" disabled />
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 15px">
              <el-col :span="4">
                <div class="title">{{ h_i18n('247efdcc3c5a6289eefaa1fe66d9bf8e') }}</div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-input v-model="data.form.approveDate" disabled />
                </div>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane name="second" :label="h_i18n('c01118aca90af005f7a2995094fe82b5')" v-if="data.form.supplyOpinion">
          <div class="tabs">
            <el-row :gutter="20">
              <el-col :span="4">
                <div class="title">{{ h_i18n('69feda8df973863d8e60cd99fd78aee0') }}</div>
              </el-col>
              <el-col :span="20">
                <div>
                  <el-radio-group v-model="data.form.supplyOpinion" disabled>
                    <el-radio :label="'Y'" size="large">{{ h_i18n('dec24919c1b59709fdbc4ba9b07ec304') }}</el-radio>
                    <el-radio :label="'N'" size="large">{{ h_i18n('d2789a2b65299b014e886dffa351aefb') }}</el-radio>
                  </el-radio-group>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 15px">
              <el-col :span="4">
                <div class="title">{{ h_i18n('9b7d101b02b97a50adb1d49a73a22493') }}</div>
              </el-col>
              <el-col :span="20">
                <div>
                  <el-input v-model="data.form.probatDescription" :rows="4" type="textarea" disabled />
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 15px">
              <el-col :span="4">
                <div class="title">{{ h_i18n('475f4da6b16ab2600a50251dc033ba6b') }}</div>
              </el-col>
              <el-col :span="8">
                <span
                  style="color: blue; font-size: 14px; cursor: pointer"
                  v-if="data.form.probatMaterialsName"
                  @click="handleClickComplain(data.form.probatMaterialsName, data.form.probatMaterialsUuid)"
                >{{ data.form.probatMaterialsName }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 15px">
              <el-col :span="4">
                <div class="title">{{ h_i18n('717e182f9fbde852fd53755f1958a076') }}</div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-input v-model="data.form.probator" disabled />
                </div>
              </el-col>
              <el-col :span="4">
                <div class="title">{{ h_i18n('077fdb544616c15bffeec14c8be49597') }}</div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-input v-model="data.form.probatDate" disabled />
                </div>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane name="third" :label="h_i18n('912e78c99aa49cef26e6e7e45fc32ca8')" v-if="data.form.profitConclusion">
          <div class="tabs">
            <el-row :gutter="20">
              <el-col :span="4">
                <div class="title">{{ h_i18n('ed8e2a400bdde2f84ca5c559ae057769') }}</div>
              </el-col>
              <el-col :span="20">
                <div>
                  <el-radio-group v-model="data.form.profitConclusion" disabled>
                    <el-radio :label="'Y'" size="large">{{ h_i18n('ef219f63c1584fc7f07b6a410312cedc') }}</el-radio>
                    <el-radio :label="'N'" size="large">{{ h_i18n('d8d1ce48ed7da1794ff296b81305580f') }}</el-radio>
                    <el-radio :label="'R'" size="large">{{ h_i18n('32525478cd5c1c93de9c71246021b595') }}</el-radio>
                  </el-radio-group>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 15px">
              <el-col :span="4">
                <div class="title">{{ h_i18n('ad2cca889618988787c7d88ef203202b') }}</div>
              </el-col>
              <el-col :span="20">
                <div>
                  <el-input v-model="data.form.conclusionDescription" :rows="4" type="textarea" disabled />
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 15px">
              <el-col :span="4">
                <div class="title">{{ h_i18n('fb12c20bf409f92f5344258a8042a44d') }}</div>
              </el-col>
              <el-col :span="20">
                <span
                  style="color: blue; font-size: 14px; cursor: pointer"
                  v-if="data.form.profitFileName"
                  @click="handleClickComplain(data.form.profitFileName, data.form.profitFileUuid)"
                >{{ data.form.profitFileName }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 15px">
              <el-col :span="4">
                <div class="title">{{ h_i18n('b58b0ea735eddc2f440897f7f0be232d') }}</div>
              </el-col>
              <el-col :span="8">
                <div style="display: flex; align-items: center">
                  <el-input v-model="data.form.profitFileAmount" type="Number" disabled :placeholder="h_i18n('f2ff33afb2323d3e5b2cd173390dbac1')" />
                  <span style="width: 50px; align-items: center">{{ h_i18n('bfdb2c6bef48d40d0280c4107100c9e0') }}</span>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="title">{{ h_i18n('610ecc9cdfa6f08b7e7a7076b75a7ff1') }}</div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-input v-model="data.form.profitCheckDate" disabled />
                </div>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane name="fourth" :label="h_i18n('0a3af28cc7fc240604cb038327aba175')" v-if="data.form.problemReviewConclusion">
          <div class="tabs">
            <el-row :gutter="20">
              <el-col :span="4">
                <div class="title">{{ h_i18n('a6c324eeea0ab23978e276c4a1ea755f') }}</div>
              </el-col>
              <el-col :span="20">
                <div>
                  <el-radio-group v-model="data.form.problemReviewConclusion" disabled>
                    <el-radio :label="'Y'" size="large">{{ h_i18n('dec24919c1b59709fdbc4ba9b07ec304') }}</el-radio>
                    <el-radio :label="'N'" size="large">{{ h_i18n('d2789a2b65299b014e886dffa351aefb') }}</el-radio>
                    <el-radio :label="'R'" size="large">{{ h_i18n('b36cb3d74bf977f73bc5458cf86026a2') }}</el-radio>
                  </el-radio-group>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 15px">
              <el-col :span="4">
                <div class="title">{{ h_i18n('5b7978d25946bd1c3a43e8e9246edeea') }}</div>
              </el-col>
              <el-col :span="20">
                <div>
                  <el-input v-model="data.form.problemReviewConclusionDescription" :rows="4" type="textarea" show-word-limit disabled />
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 15px">
              <el-col :span="4">
                <div class="title">{{ h_i18n('7c81502f8a870cc513442c199d8a59f0') }}</div>
              </el-col>
              <el-col :span="20">
                <span
                  style="color: blue; font-size: 14px; cursor: pointer"
                  v-if="data.form.problemReviewFileName"
                  @click="handleClickComplain(data.form.problemReviewFileName, data.form.problemReviewFileUuid)"
                >{{ data.form.problemReviewFileName }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 15px">
              <el-col :span="4">
                <div class="title">{{ h_i18n('8bb27ddcbc6d3b95c61742caf264ff43') }}</div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-input v-model="data.form.problemReviewDate" disabled />
                </div>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane name="fifth" :label="h_i18n('230e49a0a929b7cb836b9a290780b118')" v-if="data.form.lossMoney">
          <div class="tabs">
            <el-row :gutter="20" style="margin-top: 15px">
              <el-col :span="4">
                <div class="title">{{ h_i18n('15071246e9fe3936b91768dfc6ff7bbf') }}</div>
              </el-col>
              <el-col :span="8">
                <div style="display: flex; align-items: center">
                  <el-input v-model="data.form.lossMoney" type="Number" :placeholder="h_i18n('01b0fd6a3490c037876c5a4cbe1fdc51')" disabled />
                  <span style="width: 50px; align-items: center">{{ h_i18n('bfdb2c6bef48d40d0280c4107100c9e0') }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 15px" v-if="
              data.form.complainType == 1320 && data.form.lossMoney < 500000 ||
              data.form.complainType == 1322 && data.form.lossMoney < 100000 ||
              data.form.complainType == 2171 && data.form.lossMoney < 100000 ||
              data.form.complainType == 1328 && data.form.lossMoney < 50000
            ">
              <el-col :span="4">
                <div class="title">{{ h_i18n('6b72cb52801553df39212a56a35167e1') }}</div>
              </el-col>
              <el-col :span="20">
                <div style="display: flex; align-items: center">
                  <el-input
                    v-model="data.form.lossErrorReason"
                    :placeholder="h_i18n('7b9e06b16f19f1940f61893f7a36dc7c')"
                    :rows="4"
                    type="textarea"
                    disabled
                    maxlength="200"
                    show-word-limit
                  />
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 15px" v-if="
              data.form.complainType == 1320 && data.form.lossMoney < 500000 ||
              data.form.complainType == 1322 && data.form.lossMoney < 100000 ||
              data.form.complainType == 2171 && data.form.lossMoney < 100000 ||
              data.form.complainType == 1328 && data.form.lossMoney < 50000
            ">
              <el-col :span="4"></el-col>
              <el-col :span="20"><div style="color: #d9001b; font-size: 14px;">{{ h_i18n('3aed95390184fa80edb3d1e49c5182a2') }}</div>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 15px">
              <el-col :span="4">
                <div class="title">{{ h_i18n('d126f09905e0946d5c4bd29c36fd0fe2') }}</div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-input v-model="data.form.claimCode" disabled />
                </div>
              </el-col>
              <el-col :span="4">
                <div class="title">{{ h_i18n('c69da12eece53492bf1d99f5eb70d3dc') }}</div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-input v-model="data.form.claimStatusName" disabled />
                </div>
              </el-col>
            </el-row>
            <div style="color: #d9001b; font-size: 14px; padding: 15px 0">{{ h_i18n('36371681c443d37a7ece524d3f235f4a') }}</div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="sixth" :label="h_i18n('0952db81acc5afce272fb22a5edb72dd')" v-if="data.form.supplyFixPerson || data.form.closedConclusion">
          <div class="tabs">
            <div class="topTitle" v-if="data.form.supplyFixPerson">
              <div></div>{{ h_i18n('b45ad8768d8bad8717e55311a7ce24fc') }}</div>
            <el-row :gutter="20" style="margin-top: 15px" v-if="data.form.supplyFixPerson">
              <el-col :span="4">
                <div class="title">{{ h_i18n('3a6d63fcef1225692c8528e41335d512') }}</div>
              </el-col>
              <el-col :span="20">
                <div>
                  <el-input
                    v-model="data.form.crashProgramme"
                    :rows="4"
                    type="textarea"
                    :placeholder="h_i18n('58ff4976d648d06f121067f27e756f6e')"
                    disabled
                    maxlength="200"
                    show-word-limit
                  />
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 15px" v-if="data.form.supplyFixPerson">
              <el-col :span="4">
                <div class="title">{{ h_i18n('d1f3d079f67765e4747ce1d38daeeb19') }}</div>
              </el-col>
              <el-col :span="20">
                <div>
                  <el-input
                    v-model="data.form.radicalTreatment"
                    :rows="4"
                    disabled
                    type="textarea"
                    :placeholder="h_i18n('58ff4976d648d06f121067f27e756f6e')"
                    maxlength="200"
                    show-word-limit
                  />
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 15px" v-if="data.form.supplyFixPerson">
              <el-col :span="4">
                <div class="title">{{ h_i18n('963408aee55ba80aaa3c7c11b454e257') }}</div>
              </el-col>
              <el-col :span="8">
                <span
                  style="color: blue; font-size: 14px; cursor: pointer"
                  v-if="data.form.rectificationFileName"
                  @click="handleClickComplain(data.form.rectificationFileName, data.form.rectificationFileUuid)"
                >{{ data.form.rectificationFileName }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 15px" v-if="data.form.supplyFixPerson">
              <el-col :span="4">
                <div class="title">{{ h_i18n('6a484d5d1f047b9144f6afa90d1a4a26') }}</div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-input v-model="data.form.supplyFixPerson" disabled />
                </div>
              </el-col>
              <el-col :span="4">
                <div class="title">{{ h_i18n('46db60fbae3bc08e0a1533f2fb7a566d') }}</div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-input v-model="data.form.supplyFixDate" disabled />
                </div>
              </el-col>
            </el-row>
            <div style="color: #d9001b; font-size: 14px; padding: 15px 0">{{ h_i18n('95b30ef53f1e57a45c0ec0bf13e35d59') }}</div>
            <div class="topTitle" style="margin-top: 15px">
              <div></div>{{ h_i18n('f7df04cce2faa1fd15a9248bbb1cdd8e') }}</div>
            <el-row :gutter="20">
              <el-col :span="4">
                <div class="title">{{ h_i18n('bf0e36f5ffbd72ed50aff29c9c441c50') }}</div>
              </el-col>
              <el-col :span="20">
                <div>
                  <el-radio-group v-model="data.form.closedConclusion" disabled>
                    <el-radio :label="'P'" size="large">{{ h_i18n('23c1f39900b3af4c3263449782e288e1') }}</el-radio>
                    <el-radio :label="'F'" size="large">{{ h_i18n('32525478cd5c1c93de9c71246021b595') }}</el-radio>
                  </el-radio-group>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 15px">
              <el-col :span="4">
                <div class="title">{{ h_i18n('6daccf6cc3c5642bf3e84c3e0d7b2a49') }}</div>
              </el-col>
              <el-col :span="20">
                <div>
                  <el-input
                    v-model="data.form.closedMessage"
                    :rows="4"
                    type="textarea"
                    :placeholder="h_i18n('5fa2904fb2978b512d126372d11e850f')"
                    maxlength="200"
                    show-word-limit
                    disabled
                  />
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 15px">
              <el-col :span="4">
                <div class="title">{{ h_i18n('60eda1c4f694a5d8c50b33f71a0a7392') }}</div>
              </el-col>
              <el-col :span="8">
                <div>
                  <el-input v-model="data.form.closedDate" disabled />
                </div>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div style="margin: 10px; text-align: center">
      <h-button type="default" size="small" @click="proxy.closeWindow()">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
    </div>
  </h-inspection-page>
</template>





<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, computed } from 'vue';
import { useRoute } from 'vue-router';

const { proxy } = getCurrentInstance();
const route = useRoute();

const data = reactive({
  complainCode: '', // 抱怨单
  form: {},

  sybAllList: [], // 共产小微列表
  activeName: 'first',
  group: []
});

const complainFiles = computed(() => {
  const names = data.form.complainFileName?.split(',') ?? [];
  const uuids = data.form.complainFileUuid?.split(',') ?? [];
  return names.map((name, index) => ({ name, uuid: uuids[index] }));
});

onMounted(() => {
  if (route.query) {
    data.form.supplyCode = route.query.supplyCode;
    data.form.supplyName = route.query.supplyName;
    data.form.name = route.query.name;
    data.form.nickName = route.query.nickName;
    data.name = route.query.name;
    data.nickName = route.query.nickName;
    data.complainCode = route.query.complainCode;
    window.getItemName = route.query.name;
    window.getItemNickName = route.query.nickName;
  }
  getSybList();
  getInfo();
  // getGroup();
});

// 下载附件
const handleClickComplain = (fileName, url) => {
  proxy
    .$http({
      method: 'get',
      url: '/base/fileDownload/downloadFile',
      params: {
        filePath: url
      },
      responseType: 'blob'
    })
    .then((res) => {
      if (res.status == 200) {
        let blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel'
        }); // 文件流
        let blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a'); //模拟a链接，不支持低版本ie
        link.download = fileName;
        link.style.display = 'none';
        link.href = blobUrl;
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(link.href);
        document.body.removeChild(link);
      }
    })
    .catch((err) => {
      proxy.error(h_i18n('65e200d30c86a93c46dcafaa151028f5') + proxy.errorDispose(err.response.data || err.response || err));
    });
};

const handleClick = (val) => {
  data.activeName = val.props.name;
};

// 传高度
const inspectionUpdate = () => {
  proxy.postThisPageHeight();
};

const getInfo = () => {
  proxy
    .$http({
      method: 'post',
      url: '/base/complain/newGetOne',
      headers: { 'content-type': 'application/json' },
      params: {
        complainCode: route.query.complainCode
      }
    })
    .then((res) => {
      data.form = res.data.data;
      // 动态设置默认激活tab
      if (data.form.createType == 0 && data.form.complainType == 2171) {
        // first tab 隐藏时，按优先级选择可见的tab
        if (data.form.supplyOpinion) {
          data.activeName = 'second';
        } else if (data.form.profitConclusion) {
          data.activeName = 'third';
        } else if (data.form.problemReviewConclusion) {
          data.activeName = 'fourth';
        } else if (data.form.lossMoney) {
          data.activeName = 'fifth';
        } else if (data.form.supplyFixPerson || data.form.closedConclusion) {
          data.activeName = 'sixth';
        }
      } else {
        data.activeName = 'first';
      }
      data.form.approveConclusionName = data.form.approveConclusion == 'P' ? h_i18n('23c1f39900b3af4c3263449782e288e1') : data.form.approveConclusion == 'F' ? h_i18n('32525478cd5c1c93de9c71246021b595') : '';
      if (data.form.claimStatus == 1359) {
        data.form.claimStatusName = h_i18n('d429ae93154964b4ad9a3ca21b4e3d17');
      } else if (data.form.claimStatus == 1360) {
        data.form.claimStatusName = h_i18n('f5636cdfb2bbd8a16c00efc1566a4c3d');
      } else if (data.form.claimStatus == 1361) {
        data.form.claimStatusName = h_i18n('7fcc7a6d3a3db98cc83a02097474fa28');
      } else if (data.form.claimStatus == 1362) {
        data.form.claimStatusName = h_i18n('bff6626898f5c493fe27f87fdfce9927');
      } else if (data.form.claimStatus == 2116) {
        data.form.claimStatusName = h_i18n('4c11c20b31b6b8e1e79183ad1e6fb78b');
      } else if (data.form.claimStatus == 1800) {
        data.form.claimStatusName = h_i18n('d1f1b35b46080de518e44a4bed0b7634');
      } else if (data.form.claimStatus == 1801) {
        data.form.claimStatusName = h_i18n('3913e7c968ca888ebceff3715077c615');
      } else if (data.form.claimStatus == 1802) {
        data.form.claimStatusName = h_i18n('e71b44aae6625925a4cd463d420f2fb8');
      } else if (data.form.claimStatus == 1803) {
        data.form.claimStatusName = h_i18n('801759cbd2cd6400747a8d4edc83b42b');
      } else if (data.form.claimStatus == 1804) {
        data.form.claimStatusName = h_i18n('6f058a99d24d36098a688e5e27a89de6');
      } else {
        data.form.claimStatusName = data.form.claimStatus;
      }
      setTimeout(() => {
        inspectionUpdate();
      });
    });
};

// 获取工厂小微
const getSybList = () => {
  proxy
    .$http({
      method: 'get',
      url: '/base/basicData/selectFactoryList',
      headers: { 'content-type': 'application/json' },
      params: {
        userName: data.name,
        name: data.name,
        nickName: data.nickName
      }
    })
    .then((res) => {
      data.sybAllList = res.data;
    });
};
const getGroup = () => {
  proxy
    .$http({
      method: 'get',
      url: '/base/hpc/getGroupByUserId?userId=' + data.name,
      headers: { 'content-type': 'application/json' }
    })
    .then((res) => {
      if (res.data.success) {
        let arr = [];
        for (let i = 0; i < res.data.data.length; i++) {
          arr.push(res.data.data[i].groupName);
        }
        data.group = arr;
      }
    });
};
const DownLoadFileFromBlobResources = (blob, fileName) => {
    let suffix = fileName.substring(fileName.lastIndexOf('.'));
    let type = '';
    console.log('suffix', suffix);
    switch (suffix) {
      case '.xls':
        type = 'application/vnd.ms-excel';
        break;
      case '.xlsx':
        type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        break;
      case '.doc':
        type = 'application/msword';
        break;
      case '.docx':
        type = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        break;
      case '.png':
        type = 'image/png';
        break;
      case '.ppt':
        type = 'application/vnd.ms-powerpoint';
        break;
      case '.pptx':
        type = 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
        break;
      case '.zip':
        type = 'application/zip';
        break;
      case '.7z':
        type = 'application/x-7z-compressed';
        break;
      case '.jpeg':
        type = 'image/jpeg';
        break;
      case '.jpg':
        type = 'image/jpeg';
        break;
      case '.txt':
        type = 'text/plain';
        break;
      case '.rar':
        type = 'application/x-rar-compressed';
        break;
      case '.pdf':
        type = 'application/pdf';
        break;
      case '.tar':
        type = 'application/x-tar';
        break;
    }

    let new_blob = new Blob([blob], { type }); // 文件流
    let blobUrl = URL.createObjectURL(new_blob);
    const link = document.createElement('a'); //模拟a链接，不支持低版本ie
    link.download = fileName;
    link.style.display = 'none';
    link.href = blobUrl;
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(link.href);
    document.body.removeChild(link);
  }

const handleDownloadComplain = (fileName, url) => {
  // // 系统生成并且抱怨类型是水火电
  proxy.$http({
    method: 'get',
    url: '/base/complain/downloadHceFile',
    headers: { 'content-type': 'application/json' },
    params: {
      fileName: fileName, 
      objName: url
    },
    responseType: 'blob'
  })
  .then((res) => {
    console.log('res=============',res)
    DownLoadFileFromBlobResources(res.data,fileName)
  });
};
</script>

<style lang="scss" scoped>
:deep(.el-textarea) {
  .el-textarea__inner {
    height: auto;
    padding: 5px;
  }
}

:deep(.el-input-group__append) {
  height: 32px;
}

.btnBox {
  padding: 20px;
}

.h-hwork-form-header {
  padding: 0;
}

:deep(.haier-table-header--right) {
  position: unset !important;
}

.haier-td {
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  text-align: left;
  padding: 4px 10px;
  font-size: 14px;
  height: 35px;
  color: #666;
}

.haier-cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.haier-text-right {
  text-align: right;
}

.tab_box {
  padding-top: 10px;

  .tabs_style {
    box-shadow: none;
    overflow: hidden;
    -webkit-box-shadow: none;
    border: 0px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

    :deep(.is-top) {
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      border: 0;

      :deep(.el-tabs__item) {
        background-color: #fff;
        border: #fff solid 1px;
        border-bottom: 0px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        margin: 0.5px 0.5px 0 0.5px;
      }

      :deep(.is-active) {
        background-color: #fff;
        border: 1px solid #fff;
      }
    }
  }

  .tabs {
    .topTitle {
      background-color: rgba(247, 248, 250, 1);
      font-size: 14px;
      padding: 0 10px;
      line-height: 24px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;

      > div {
        width: 2px;
        height: 24px;
        background: #165dff;
        margin-right: 5px;
        display: inline-block;
      }
    }

    .title {
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: 100%;
    }
  }
}
.blueClick {
  color: #165dff;
  text-decoration: none;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  &:hover {
    color: #4080ff;
  }
  &:active {
    color: #0e42d2;
  }
}
</style>